<template>
  <div
    class="max-w-1600 mx-auto w-full relative min-h-full"
    :class="[
      {'rounded-t-9 bg-canvas min-h-full' : isPaperShape},
      isDarkMode ? 'text-app-color': 'text-dark-600'
    ]"
  >
    <div
      class="px-20 md:pr-40 pb-150 mx-auto"
      :class="[
        isPoseidonTheme ? 'bg-notebooks-poseidon' : '',
        isPaperShape ? 'rounded-t-9 pt-40 md:pl-40 bg-canvas' : 'pt-31 md:pl-25 bg-book'
      ]"
    >
      <!-- header -->
      <div class="mb-40">
        <h1 class="text-26 font-bold leading-none">Inbox</h1>
      </div>
      <!-- content -->
      <div>
        <div class="flex">
          <Switcher v-model="activeState" :is-dark-mode="isDarkMode" class="max-w-320" @onChange="onChange">
            <template #title0>
              <p class="flex justify-center items-center">About you <span v-if="hasUnreadPersonalMessages" class="w-8 h-8 rounded-full bg-brand ml-10 flex-shrink-0" /></p>
            </template>
            <template #title1>
              <p class="flex justify-center items-center">Stay up-to-date <span v-if="hasUnreadGeneralMessages" class="w-8 h-8 rounded-full bg-brand ml-10 flex-shrink-0" /></p>
            </template>
          </Switcher>
        </div>

        <div v-if="filteredNotifications.length > 0" class="mt-40">
          <NotificationItem
            v-for="(notification, index) in filteredNotifications"
            :key="notification.id"
            :notification="notification"
            :has-border="index !== 0"
          />
        </div>

        <div v-else class="text-center w-full max-w-420 rounded-10 py-50 mt-40" :class="isDarkMode ? 'bg-project' : 'bg-grey-450 '">
          <img :src="require(`@/assets/images/inbox.svg`)" class="w-full max-w-200 mx-auto" alt="teams">
          <p class="font-bold text-17 mt-50">Your inbox is empty</p>
          <p class="text-grey-1050">Once there is news, we'll let you know.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Switcher from '@/components/shared/Switcher'

import { defineComponent, computed, ref, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import NotificationItem from '@/components/inbox/NotificationItem'

export default defineComponent({
  components: {
    Switcher,
    NotificationItem
  },

  setup () {
    const { state, getters, dispatch } = useStore()
    const route = useRoute()

    const activeState = ref(true)

    const settings = computed(() => state.settings.settings)

    const isDarkMode = computed(() => getters.isDarkMode)
    const isPaperShape = computed(() => getters.isPaperShape)
    const isPoseidonTheme = computed(() => getters.isPoseidonTheme)

    const filteredNotifications = computed(() => {
      const category = activeState.value ? 'personal' : 'general'

      return state.inbox.notifications[category] || []
    })

    const hasUnreadGeneralMessages = computed(() => state.inbox.notifications.general?.some(item => item.status === 'unread'))
    const hasUnreadPersonalMessages = computed(() => state.inbox.notifications.personal?.some(item => item.status === 'unread'))

    onMounted(() => {
      nextTick(() => {
        const ids = state.inbox.notifications.personal.filter(item => item.status === 'unread').map(item => item.id)

        if (ids.length > 0) dispatch('updateNotificationStatus', { ids })

        dispatch('getBook', route.params.id).then(res => {
          if (res.id && res.chat?.id) {
            dispatch('getMessages', {
              bookId: res.id,
              chatId: res.chat.id
            })
          }
        })
      })
    })

    function onChange () {
      const ids = filteredNotifications.value.filter(item => item.status === 'unread').map(item => item.id)
      if (ids.length > 0) {
        setTimeout(() => dispatch('updateNotificationStatus', { ids }), 1000)
      }
    }

    return {
      // data
      activeState,
      // computed
      settings,
      isDarkMode,
      isPaperShape,
      isPoseidonTheme,
      filteredNotifications,
      hasUnreadGeneralMessages,
      hasUnreadPersonalMessages,
      // functions
      onChange
    }
  }
})
</script>
